import { Component, Input, OnInit } from '@angular/core'
import { MarketplaceActionRequiredIssue } from 'src/app/account/services/issue'

@Component({
  selector: 'marketplace-action-required-issue',
  templateUrl: './marketplace-action-required-issue.component.html',
  styleUrls: ['./marketplace-action-required-issue.component.scss'],
  standalone: false,
})
export class MarketplaceActionRequiredIssueComponent implements OnInit {
  @Input() issue: MarketplaceActionRequiredIssue = null

  constructor() {}

  ngOnInit() {}
}
